import { reactive } from "vue";

export const store = reactive({
	navBarHeight: 0,
	navDrawerOpen: false
});

export const mutations = {
	changeNavBarHeight(newHeight) {
		store.navBarHeight = newHeight;
	},
	toggleNavDrawer() {
		store.navDrawerOpen = !store.navDrawerOpen;
	},
	closeNavDrawer() {
		store.navDrawerOpen = false;
	},
	openNavDrawer() {
		store.navDrawerOpen = true;
	}
};
